module.exports = __webpack_public_path__ + "static/media/shipping_icon.63e51e8c.svg";